import React, {useState, useEffect} from "react"
import ClueDelivery from "../../footer/ClueDelivery"

function KeypadLock(props) {
    const [inputValue, setInputValue] = useState("")
    const [inputCloakroom, setInputCloakroom] = useState({
        garments: "",
        bags: "",
        wornAccesories: "",
        carriedItems: ""
    })
    const [inputFingerprint, setInputFingerprint] = useState({
        thumb: "",
        index: "",
        middle: "",
        fourth: "",
        fifth: ""
    })
    const [count, setCount] = useState(-1)
    const [, setFlash] = useState("")
    const [colorChange] = useState([
        "indianRed", 
        "darkgray",
        "indianRed",
        "darkgray",
        "indianRed",
        "darkgray",
        "indianRed",
        "darkgray"
    ]) 
    const [inputs, setInputs] = useState("")
    const [sendNudge, setSendNudge] = useState(false)
    const [nudgeContent] = useState({
        nudgeHeader: "You Have The Right Idea!",
        nudgeText: "But instead of using the quantity of items in each category from Logan's cloakroom code, you must use the numbers which represent the category. e.g. Garments = 8"
    })
    
    const cloakroomAlternateCode = "1220"
    const cloakroom = [
        {
            id: 0,
            text: "Garments",
            name: "garments",
            value: inputCloakroom.garments
        },
        {
            id: 1,
            text: "Bags",
            name: "bags",
            value: inputCloakroom.bags
        },
        {
            id: 2,
            text: "Worn Accesories",
            name: "wornAccesories",
            value: inputCloakroom.wornAccesories
        },
        {
            id: 3,
            text: "Carried Items",
            name: "carriedItems",
            value: inputCloakroom.carriedItems
        }
    ] 
    const fingerprint = [
        {
            id: 0,
            name: "thumb",
            size: "2",
            text: " - ",
            value: inputFingerprint.thumb
        },
        {
            id: 1,
            name: "index",
            size: "2",
            text: " - ",
            value: inputFingerprint.index
        },
        {
            id: 2,
            name: "middle",
            size: "2",
            text: " - ",
            value: inputFingerprint.middle
        },
        {
            id: 3,
            name: "fourth",
            size: "1",
            text: " - ",
            value: inputFingerprint.fourth
        },
        {
            id: 4,
            name: "fifth",
            size: "2",
            text: "",
            value: inputFingerprint.fifth
        },
    ]
    
    function handleChangeCloakroom(event) {
        const {name, value} = event.target
        setInputCloakroom({
            ...inputCloakroom,
            [name]: value
        })
    }
    
    useEffect(() => {
        const updatedCloakroom = inputCloakroom.garments.toString() + inputCloakroom.bags.toString() + inputCloakroom.wornAccesories.toString() + inputCloakroom.carriedItems.toString()
        setInputValue(updatedCloakroom)
    }, [inputCloakroom])
    
    function handleChangeFingerprint(event) {
        const {name, value} = event.target
        setInputFingerprint({
            ...inputFingerprint,
            [name]: value
        })
    }
    
    useEffect(() => {
        const updatedFingerprint = inputFingerprint.thumb.toString() + inputFingerprint.index.toString() + inputFingerprint.middle.toString() + inputFingerprint.fourth.toString() + inputFingerprint.fifth.toString()
        setInputValue(updatedFingerprint)
    }, [inputFingerprint])
        
    function handleSubmit(event) {
        event.preventDefault()
        if (inputValue.toLowerCase() === props.correct) {
            props.callBackStatus()
        } else if (props.currentPage === 2 && inputValue === cloakroomAlternateCode) {
            console.log('alternate code detected')
            setSendNudge(true)
            document.getElementById("printer").play()
            setCount(0)
        } else {
            setCount(0)     
        }
    }
    
    function clearNudge() {
        setSendNudge(false)
    }
    
     useEffect(() => {
        if (count === 0) { 
            setFlash(() => setInterval(() => increaseFlashCount(), 250)) 
        } else if (count < colorChange.length) {
            document.getElementById("keypadLock").style.backgroundColor = colorChange[count]
        } else {
            document.getElementById("keypadLock").style.backgroundColor = "var(--mainRedColor)"
//            setInputValue("")
            setFlash(prevFlash => clearInterval(prevFlash))
        }
    }, [count, colorChange])
    
    function increaseFlashCount() {
        setCount(prevCount => prevCount + 1)
    }   
    
    const cloakroomInputs = cloakroom.map(category => {
        return <label key={category.id}>{category.text} = <input placeholder="?" maxLength="1" size="1" name={category.name} value={category.value} onChange={handleChangeCloakroom}/>. </label>
    })
    
    const fingerprintInputs = fingerprint.map(finger => {
        return <label key={finger.id}><input maxLength={finger.size} size={finger.size} placeholder="?" value={finger.value} name={finger.name} onChange={handleChangeFingerprint}/>{finger.text}</label>
    })
        
    useEffect(() => {
        if (props.currentPage === 2) {
            setInputs(cloakroomInputs)
        } else if (props.currentPage === 3) {
            setInputs(fingerprintInputs)
        } else {
            setInputs("")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue, props.currentPage, inputCloakroom, inputFingerprint])
    
    return (
        <div id="keypadLock">
            <img id="padlockImage" src={"./images/icons/locked.png"} alt="a locked padlock" />
            <div id="keypadLockText">
                <h2>Keypad locked!</h2> 
                <h3>{props.requiredText} to unlock suspect elimination.</h3>
                <form>
                    {inputs}
                    {props.currentPage === 4 | props.currentPage === 1 ? "" : <button className="standardButton" onClick={handleSubmit}>Submit</button>}
                </form>            
            </div>
            <ClueDelivery clueHeader={nudgeContent.nudgeHeader} clue={nudgeContent.nudgeText} handleClick={clearNudge} sendClue={sendNudge} cloakroomNudge={true} />
        </div>
    )
}

export default KeypadLock